import { useAuthContext } from '../contexts/AuthContext'
import { adminRouteNames } from '../routes/routesNames/adminRouteNames'
import { backofficeRouteNames } from '../routes/routesNames/backofficeRouteNames'
import {
  operationalDynamicRoutes,
  operationalRouteNames
} from '../routes/routesNames/operationalRouteNames'
import {
  responsibleDynamicRoutes,
  responsibleRouteNames
} from '../routes/routesNames/responsibleRouteNames'
import {
  therapistDynamicRoutes,
  therapistRouteNames
} from '../routes/routesNames/therapistRouteNames'

export function usePersonaBaseUrl() {
  const { personaSession } = useAuthContext()
  switch (personaSession?.personaType) {
    case 'ADMIN':
      return adminRouteNames.home
    case 'OPERATIONAL':
      return operationalRouteNames.home
    case 'RESPONSIBLE':
      return responsibleRouteNames.home
    case 'THERAPIST':
      return therapistRouteNames.home
    case 'SUPERADMINISTRATOR':
      return backofficeRouteNames.home
    default:
      return '/'
  }
}

export function useUserSharedBaseRoutes() {
  const { personaSession } = useAuthContext()
  switch (personaSession?.personaType) {
    case 'OPERATIONAL':
      return {
        static: operationalRouteNames,
        dynamic: operationalDynamicRoutes
      }
    case 'RESPONSIBLE':
      return {
        static: responsibleRouteNames,
        dynamic: responsibleDynamicRoutes
      }
    case 'THERAPIST':
      return {
        static: therapistRouteNames,
        dynamic: therapistDynamicRoutes
      }
    default:
      return null
  }
}
